<template>
  <RouterView />

  <OfflineModal :open="isOfflineModalOpen" />
</template>

<script setup>
import { onMounted, onUnmounted, watch } from 'vue';
import OfflineModal from '@/components/modal/OfflineModal.vue';
import useAuthStore from '@/store/modules/auth.js';
import useGtmHook from '@/hooks/useGtm.js';
import useOfflineHook from '@/hooks/useOffline.js';
import useBackgroundMusicHook from '@/hooks/useBackgroundMusic.js';

const authStore = useAuthStore();

const { loadGoogleAnalyticsScript } = useGtmHook();
const { isOfflineModalOpen } = useOfflineHook();
const { addBackgroundMusicListener, removeBackgroundMusicListener } = useBackgroundMusicHook();

watch(
  () => authStore.user.msisdn,
  loadGoogleAnalyticsScript,
  { immediate: false },
);

onMounted(() => {
  document.getElementById('loader-style')?.remove?.();

  addBackgroundMusicListener();
});

onUnmounted(removeBackgroundMusicListener);
</script>
